export const userIsSignedInAndLoaded = (state) => state.user.id !== undefined;